// extracted by mini-css-extract-plugin
module.exports = {"textarea":"i_AW","label":"i_AX"};